import React from "react";
import { motion } from "framer-motion";
import { Reveal, Overline } from "./primitives";
import { CASE_STUDIES, IMAGES } from "./content";

const EASE = [0.16, 1, 0.3, 1];

const ROWS = [
  { label: "The Challenge", key: "challenge" },
  { label: "The Vision", key: "vision" },
  { label: "The Transformation", key: "transformation" },
  { label: "The Experience", key: "experience" },
  { label: "The Result", key: "result" },
];

function Study({ study, image, index }) {
  const flip = index % 2 === 1;
  return (
    <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-16">
      <div className={`md:col-span-7 ${flip ? "md:order-2" : ""}`}>
        <Reveal className="clip-frame relative aspect-[16/11] overflow-hidden">
          <img src={image} alt={study.name} loading="lazy" className="h-full w-full object-cover" />
        </Reveal>
      </div>
      <div className={`md:col-span-5 ${flip ? "md:order-1" : ""}`}>
        <Reveal>
          <span className="overline text-copper">{study.location}</span>
          <h3 className="mt-4 font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl">
            {study.name}
          </h3>
          <dl className="mt-8">
            {ROWS.map((r) => (
              <div key={r.key} className="border-t border-ink/10 py-4">
                <dt className="overline text-ink/40">{r.label}</dt>
                <dd className="mt-1 leading-relaxed text-ink/75">{study[r.key]}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </div>
  );
}

export default function CaseStudies() {
  return (
    <section id="projects" data-testid="case-studies-section" className="relative bg-warm py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE }}
          className="mb-20 flex flex-col justify-between gap-6 md:mb-32 md:flex-row md:items-end"
        >
          <div className="max-w-[20ch]">
            <Overline className="text-copper">Upcoming Work</Overline>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-6xl lg:text-7xl">
              Legacies being built, quietly.
            </h2>
          </div>
          <p className="max-w-[34ch] text-ink/60 leading-relaxed">
            A handful of destinations. Each one designed to be remembered — and to perform.
          </p>
        </motion.div>

        <div className="space-y-28 md:space-y-44">
          {CASE_STUDIES.map((s, i) => (
            <Study key={s.name} study={s} image={IMAGES.caseStudies[i]} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
